// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from Skeleton.module.scss  */
.Skeleton-module-Root__LY {
  height: 14px;
  border-radius: 4px;
  background-color: var(--skeleton-background-default); }
  .Skeleton-module-Root__LY.Skeleton-module-animated_321 {
    background: linear-gradient(to bottom right, #dee1eb 8%, #f6f7fa 38%, #dee1eb 54%);
    background-size: 1000px 640px;
    animation: Skeleton-module-skeleton_muH 2s;
    animation-timing-function: ease-out;
    animation-iteration-count: infinite;
    animation-fill-mode: forwards; }

@keyframes Skeleton-module-skeleton_muH {
  0% {
    background-position: 0 0; }
  100% {
    background-position: 100% 50%; } }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Skeleton/Skeleton.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC;EACE,YAAY;EACZ,kBAAkB;EAClB,oDAAoD,EAAE;EACtD;IACE,kFAAkF;IAClF,6BAA6B;IAC7B,0CAA0C;IAC1C,mCAAmC;IACnC,mCAAmC;IACnC,6BAA6B,EAAE;;AAEnC;EACE;IACE,wBAAwB,EAAE;EAC5B;IACE,6BAA6B,EAAE,EAAE","sourcesContent":["/*  imported from Skeleton.module.scss  */\n.Skeleton-module-Root__LY {\n  height: 14px;\n  border-radius: 4px;\n  background-color: var(--skeleton-background-default); }\n  .Skeleton-module-Root__LY.Skeleton-module-animated_321 {\n    background: linear-gradient(to bottom right, #dee1eb 8%, #f6f7fa 38%, #dee1eb 54%);\n    background-size: 1000px 640px;\n    animation: Skeleton-module-skeleton_muH 2s;\n    animation-timing-function: ease-out;\n    animation-iteration-count: infinite;\n    animation-fill-mode: forwards; }\n\n@keyframes Skeleton-module-skeleton_muH {\n  0% {\n    background-position: 0 0; }\n  100% {\n    background-position: 100% 50%; } }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
